/* eslint-disable */
import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";
import VPagination from "@hennge/vue3-pagination";
import KriInfoModal from "./KriInfoModal.vue";
import MitigationInfoModal from "./Mitigationinfomodal.vue";
import ManageRiskItemModal from "./ManageRiskItemModal.vue";
import ViewRiskInfoModal from "./ViewRiskInfoModal.vue";

export default {
    name: "RiskListModal",
    components: {
        customModal,
        VPagination,
        KriInfoModal,
        MitigationInfoModal,
        ManageRiskItemModal,
        ViewRiskInfoModal,
    },
    props: {
        data: Object,
    },
    emits: ["closeModal"],

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",
            studyId: "",
            loading: false,
            riskList: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            totalPages: 1,

            // Drill-down into the existing KRI popup
            selectedCtqForKri: null,
            showKriModal: false,

            // Create / Edit risk item popup
            showManageRiskModal: false,
            riskEditData: null,

            selectedCtqForMitigation: null,
            showMitigationModal: false,

            selectedRiskForView: null,
            showViewRiskModal: false,
        };
    },

    mounted() {
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        if (this.data) {
            this.fetchRiskList();
        }
    },

    watch: {
        data: {
            deep: true,
            handler(newVal) {
                if (newVal) {
                    this.currentPage = 1;
                    this.fetchRiskList();
                }
            },
        },
    },

    methods: {
        async fetchRiskList(page = this.currentPage) {
            this.loading = true;
            this.riskList = [];

            try {
                const response = await axios.get(
                    `${this.baseurl}/forms/ctq/getallrisk`,
                    {
                        params: {
                            StudyId: this.studyId,
                            CtqId: this.data?.ctqid,
                            pageindex: page,
                            pagesize: this.pageSize,
                        },
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const result = response.data;

                if (result.entities && Array.isArray(result.entities)) {
                    this.riskList = result.entities.map((i) => ({ ...i, expanded: false }));
                    this.totalCount = result.totalCount || 0;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                } else if (Array.isArray(result)) {
                    this.riskList = result.map((i) => ({ ...i, expanded: false }));
                    this.totalCount = result.length;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                } else if (result) {
                    this.riskList = [{ ...result, expanded: false }];
                    this.totalCount = 1;
                    this.totalPages = 1;
                }

                this.currentPage = page;
            } catch (error) {
                console.error("Error fetching risk list:", error);
                this.riskList = [];
                this.totalCount = 0;
                this.totalPages = 0;
            } finally {
                this.loading = false;
            }
        },

        loadPage(page) {
            this.fetchRiskList(page);
        },

        closeModal() {
            this.$emit("closeModal");
        },

        // KriInfoModal is keyed off the CtQ (ctqid), not an individual risk,
        // so we hand it the original CtQ record this modal was opened with.
        viewKriForRisk(item) {
            this.selectedCtqForKri = this.data;
            this.showKriModal = true;
        },

        closeKriModal() {
            this.showKriModal = false;
            this.selectedCtqForKri = null;
        },

        ViewMitigation(item) {
            this.selectedCtqForMitigation = item;
            this.showMitigationModal = true;
        },

        closeMitigationModal() {
            this.showMitigationModal = false;
            this.selectedCtqForMitigation = null;
        },

        viewRisk(item) {
            this.selectedRiskForView = item;
            this.showViewRiskModal = true;
        },

        closeViewRiskModal() {
            this.showViewRiskModal = false;
            this.selectedRiskForView = null;
        },

        // ── Create / Edit risk item ──────────────────────────────────────

        openManageRiskModal(item) {
            this.riskEditData = item ? { ...item } : null;
            this.showManageRiskModal = true;
        },

        closeManageRiskModal() {
            this.showManageRiskModal = false;
            this.riskEditData = null;
        },

        reloadRiskList() {
            this.currentPage = 1;
            this.fetchRiskList();
        },

        truncate(text) {
            if (!text) return "";
            return text.length > 120 ? text.substring(0, 120) + "..." : text;
        },

        toggleExpand(item) {
            item.expanded = !item.expanded;
        },

        riskLevelBadgeClass(level) {
            switch ((level || "").toLowerCase()) {
                case "high":
                    return "badge badge-warning";
                case "medium":
                    return "badge badge-info";
                case "low":
                    return "badge badge-success";
                default:
                    return "badge badge-secondary";
            }
        },
    },
};